import { Outlet, useLocation } from 'react-router-dom';
import { AuthAsidePanel } from '@/core/layouts/auth/AuthAsidePanel';
import { useEffect } from 'react';
import { shouldSkipColdSessionBootstrap } from '@/utils/sessionBootstrap';
import { clearWorkspaceScopeStorage } from '@/utils/workspaceScope';

export function AuthShell() {
  const location = useLocation();

  useEffect(() => {
    if (shouldSkipColdSessionBootstrap(location.pathname)) {
      clearWorkspaceScopeStorage();
    }
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-page dark:bg-slate-950 lg:flex">
      <aside className="relative hidden h-screen w-1/2 shrink-0 overflow-hidden lg:fixed lg:inset-y-0 lg:left-0 lg:z-10 lg:block">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-slate-900 to-primary-950" />
        <div className="absolute right-10 top-1/3 h-64 w-64 rounded-full bg-primary-500/10 blur-3xl" />
        <AuthAsidePanel />
      </aside>

      <main className="relative flex min-h-screen flex-1 flex-col lg:ml-[50%]">
        <div className="flex flex-1 items-start justify-center overflow-y-auto p-6 py-12 sm:items-center sm:p-10">
          <div className="w-full max-w-md">
            <Outlet />
          </div>
        </div>
      </main>
    </div>
  );
}
